<template>
  <div class="wimut-menu">
    <div class="wimut-content">
      <div class="wimut-left">
        <img src="../assets/logo.png" class="logo" />
        <div>
          <p>บริษัท ครอบครัววิมุต จำกัด</p>
          <!-- WIMUT FAMILY COMPANY LIMITED -->
          <span>WIMUT FAMILY CO., LTD.</span>
        </div>
      </div>
      <div class="wimut-right">
        <div class="item">
          <p>
            ที่อยู่: <span
              >127/126 ซอยรามอินทรา 40 แยก 8-1 ตำบลนวลจันทร์ อำเภอบึงกุ่ม
              จังหวัดกรุงเทพมหานคร 10240</span
            >
          </p>
        </div>
        <div class="item">
          <p>โทรศัพท์: <span>08 2663 5523</span></p>
        </div>
        <div class="item">
          <p>จดหมาย: <span>ads@wimutfamily.com</span></p>
        </div>
      </div>
    </div>
    <div class="wimut-menubox">
      <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">
        บริษัท
      </div>
      <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">ทีม</div>
      <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
        ให้บริการ
      </div>
      <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">
        ติดต่อเรา
      </div>
      <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
        ข้อกำหนดและเงื่อนไข
      </div>
      <!-- <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
        นโยบายความเป็นส่วนตัว
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "categories" });
          break;
        case 3:
          this.$router.push({ path: "destination" });
          break;
        case 4:
          this.$router.push({ path: "privacy" });
          break;
        case 5:
          this.$router.push({ path: "conditions" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wimut-menu {
  background-color: #00387a;

  .wimut-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 28px 200px;

    .wimut-left {
      width: 500px;
      display: flex;
      align-items: center;

      .logo {
        margin-right: 16px;
        width: 40px;
        height: 31px;
      }

      p {
        color: #fff;
        font-size: 28px;
        font-family: Niramit, Niramit;
        font-weight: bold;
      }

      span {
        color: #fff;
        font-size: 26px;
        font-family: Niramit, Niramit;
        font-weight: bold;
      }
    }

    .wimut-right {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex: 1;

      .item {
        margin-right: 50px;
        width: 33.3%;
        p {
          color: rgba(255, 255, 255, 0.6);
        }

        span {
          color: #fff;
        }
      }
    }
  }

  .wimut-menubox {
    display: flex;
    align-items: center;
    padding: 20px 310px;
    font-size: 18px;
    font-family: ArialMT;
    color: rgba(255, 255, 255, 0.8);
    border-top: 1px solid rgba(255, 255, 255, 0.4);

    div {
      cursor: pointer;
      margin-right: 80px;
    }

    div:nth-child(5) {
      margin-right: 0;
    }
  }

  .select {
    font-weight: 600;
    color: #f26621;
  }
}
</style>
